<template>
  <div class="container">
    <navigation/>
    <div class="categories">
        <h1>Szkło grafika</h1>
      <div v-show="showMessage" class="message">{{message}}</div>
      <form @submit.prevent="addCategory" class="addCategoryForm">
        <h2 class="heading">Dodaj kategorie</h2>
        <div class="lform">
          <label for="name">Nazwa</label>
          <input name="name" type="text" placeholder="np. gałęzie liście trawa" v-model="currName" required class="name ">
        </div>
        <p class="info">Wybierz ikonę dla nowej kategorii</p>
        <input class="inputfile" type="file" @change="selectFile" name="file" id="file" required accept="image/jpg, image/jpeg, image/png">
        <div class="buttons">
        <label class="inputlabel" for="file"> 
              <img src="@/assets/upload.svg" class="upload">
              Wybierz miniaturę
        </label>
        <input type="submit" value="Dodaj!" class="subBtn">
        </div>
      </form>
      <!-- <form submit.prevent>
        <h2>Usuń kategorie</h2>
        <ul class="list">
          <div class="list_item" v-for="category in categories" :key="category.id">
            <li>{{category.name}}</li>
            <button @click="test(category)">Usuń</button>
          </div>
        </ul>
      </form> -->
      <form @submit.prevent="uploadImages" class="addImgForm">
      <h2 class="heading">Dodaj zdjęcia do kategorii</h2>
        <select class="categoriesSelect" @change="selectedCategory" name="categories" >
          <option>Wybierz kategorie</option>
          <option v-for="category in categories" :value="category.to" :key="category.id">{{category.name}}</option>
        </select>
        <div class="buttons">
        <label class="inputlabel" for="files">
              <img src="@/assets/upload.svg" class="upload">
              Wybierz zdjęcia
        </label>
        <input name="files" type="file" class="inputfile files" id="files" multiple accept="image/jpeg, image/jpg, image/png" required @change="selectMultipleFiles">
        <input type="submit" class="subBtn" value="Dodaj!" >
        </div>
      </form>
      <div class="counter">Wybrano {{total}} plików.</div>
      <progress :value="done" :max="total" class="progress">test</progress>
      <p v-if="uploading">Zdjęcia są wysyłane, poczekaj chwilę.</p>
    </div>
    <div class="center">
    <router-link tag="button" class="backBtn" to="/admin">Wróć na główną strone</router-link>
    </div>
    <Footer/>
  </div>
</template>

<script>
import { mapMutations, mapState } from 'vuex';
import navigation from '@/components/adminNav.vue';
import Footer from '@/components/Footer.vue';
export default {
  components:{
    navigation, Footer
  },
  computed:{
    ...mapState({
      image: state=>state.offer.currImage,
      uploading: state=>state.offer.uploading,
      message: state=>state.offer.uploadMessage,
      showMessage: state=>state.offer.showMessage,
      categories: state=>state.szkloCategories.categories,
      total: state=>state.offer.totalFiles,
      done: state=>state.offer.doneFiles
    }),
    currName:{
      get(){
          return this.$store.state.offer.currName;
      },
      set(value){
        return this.$store.commit('setName', value);
      }
    }
  },
  methods:{
    ...mapMutations(['addCategory', 'selectFile', 'selectMultipleFiles', 'bindCategories', 'uploadImages', 'selectedCategory']),
  },
  mounted(){
    this.bindCategories();
  }
}
</script>

<style scoped lang="scss">
.backBtn{
  color: white;
  background: black;
  border: none;
  padding: 12px 24px;
  margin: 24px 0;
}
.center{
  display: flex;
  justify-content: center;
  align-items: center;
}
.categoriesSelect{
  margin: 6px 0;
}
.progress{
  width: 100%;
}
.list_item{
  display: flex;
  justify-content: space-between;
  align-items: center;
  list-style: none;
  margin: 6px 0;
}
.upload{
  width: 16px;
  margin: 0 6px;
}
.buttons{
  display: flex;
  flex-direction: row;
}
.inputfile {
	width: 0.1px;
	height: 0.1px;
	opacity: 0;
	overflow: hidden;
	position: absolute;
	z-index: -1;
}
.inputlabel {
    padding: 6px 16px;
    color: white;
    background-color: black;
    display: flex;
    justify-content: space-around;
    align-items: center;
}

.lform{
  display: flex;
  justify-content: flex-start;
  flex-direction: column;
}
.footer_container{
  // position: absolute;
  width: 100%;
}
.categories{
  margin-top: 120px;
  padding-left: 34px;
  position: relative;
  padding: 0 34px;
}
.message{
  position: absolute;
  top: -60px;
  left: 0;
  width: 100%;
  height: 40px;
  background: rgb(238, 238, 238);
  z-index: 100;
  display: flex;
  justify-content: center;
  align-items: center;
}
.name{
  width: 200px;
  height: 40px;
  padding: 12px;
  font-size: 17px;
}
.info{
  margin: 6px 0;
}
.addImgForm{
  margin: 42px 0;
}
.subBtn{
  background: black;
  border: none;
  padding: 6px 12px;
  color: white;
  margin: 0 6px;
}
@media (min-width: 1440px){
  .categories{
    padding: 0 100px;
  }
  .footer_container{
    position: absolute;
    bottom: 0;
    left: 0;
  }
}
</style>